<template>
    <jet-form-section @submitted="updatePassword">
        <template #title>{{ $t("profile.password.title") }}</template>

        <template #description>{{
            $t("profile.password.description")
        }}</template>

        <template #form>
            <div class="sm:col-span-4 col-span-6">
                <jet-label
                    for="current_password"
                    :value="$t('profile.password.current_password')"
                />
                <jet-input
                    id="current_password"
                    ref="current_password"
                    v-model="form.current_password"
                    type="password"
                    class="mt-1 block w-full"
                    autocomplete="current-password"
                />
                <jet-input-error
                    :message="form.errors.current_password"
                    class="mt-2"
                />
            </div>

            <div class="sm:col-span-4 col-span-6">
                <jet-label
                    for="password"
                    :value="$t('profile.password.new_password')"
                />
                <jet-input
                    id="password"
                    ref="password"
                    v-model="form.password"
                    type="password"
                    class="mt-1 block w-full"
                    autocomplete="new-password"
                />
                <jet-input-error :message="form.errors.password" class="mt-2" />
            </div>

            <div class="sm:col-span-4 col-span-6">
                <jet-label
                    for="password_confirmation"
                    :value="$t('profile.password.confirm_password')"
                />
                <jet-input
                    id="password_confirmation"
                    v-model="form.password_confirmation"
                    type="password"
                    class="mt-1 block w-full"
                    autocomplete="new-password"
                />
                <jet-input-error
                    :message="form.errors.password_confirmation"
                    class="mt-2"
                />
            </div>
        </template>

        <template #actions>
            <Button
                :loading="form.processing"
                :recently-successful="form.recentlySuccessful"
                size="sm"
                >{{ $t("profile.password.update_password") }}</Button
            >
        </template>
    </jet-form-section>
</template>

<script>
import JetButton from "../../Jetstream/Button.vue";
import JetFormSection from "../../Jetstream/FormSection.vue";
import JetInput from "../../Jetstream/Input.vue";
import JetInputError from "../../Jetstream/InputError.vue";
import JetLabel from "../../Jetstream/Label.vue";
import Button from "@/components/ui/button/Button.vue";

export default {
    components: {
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        Button,
    },

    data() {
        return {
            form: this.$inertia.form({
                current_password: "",
                password: "",
                password_confirmation: "",
            }),
        };
    },

    methods: {
        updatePassword() {
            this.form.put(route("user-password.update"), {
                errorBag: "updatePassword",
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
                onError: () => {
                    if (this.form.errors.password) {
                        this.form.reset("password", "password_confirmation");
                        this.$refs.password.focus();
                    }

                    if (this.form.errors.current_password) {
                        this.form.reset("current_password");
                        this.$refs.current_password.focus();
                    }
                },
            });
        },
    },
};
</script>
